import { defineRule } from 'vee-validate'
import { i18n } from '@/i18n.js'

const alphaSpacesDash = {
  en: /^[A-Z\s_-]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s_-]*$/i,
  da: /^[A-ZÆØÅ\s_-]*$/i,
  de: /^[A-ZÄÖÜß\s_-]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ\s_-]*$/i,
   
  fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی\s_-]*$/,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s_-]*$/i,
  it: /^[A-Z\xC0-\xFF\s_-]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s_-]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ\s_-]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s_-]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s_-]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s_-]*$/i,
  ru: /^[А-ЯЁ\s_-]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s_-]*$/i,
  sr: /^[A-ZČĆŽŠĐ\s_-]*$/i,
  sv: /^[A-ZÅÄÖ\s_-]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ\s_-]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ\s_-]*$/i,
   
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s_-]*$/,
  az: /^[A-ZÇƏĞİıÖŞÜ\s_-]*$/i
}

const alphaSpacesDashFunction = (value, { locale } = {}) => {
  if (Array.isArray(value)) {
    return value.every(val => alphaSpacesDashFunction(val, { locale })) || i18n.global.t('validation.alphaSpacesDash')
  }

  // Match au moins une locale.
  if (!locale) {
    return (
      Object.keys(alphaSpacesDash).some(loc => alphaSpacesDash[loc].test(value)) ||
      i18n.global.t('validation.alphaSpacesDash')
    )
  }

  return (alphaSpacesDash[locale] || alphaSpacesDash.en).test(value) || i18n.global.t('validation.alphaSpacesDash')
}

defineRule('alpha_spaces_dash', (value, args) => {
  return alphaSpacesDashFunction(value, { locale: args[0] })
})
